module.exports = __webpack_public_path__ + "assets/img/INTERIOR6.e9245ef7.png";